/*
 * @Author: xiaolong.xu
 * @Date: 2023-03-03 16:51:37
 * @LastEditors: 最后编辑
 * @LastEditTime: 2023-03-03 16:52:35
 * @Description: 时间处理方法
 */
import dayjs from 'dayjs'
import localeData from 'dayjs/plugin/localeData'
import utc from 'dayjs/plugin/utc'
import weekday from 'dayjs/plugin/weekday'

// 扩展utc功能
dayjs.extend(utc)
dayjs.extend(weekday)
dayjs.extend(localeData)
dayjs.locale('zh-cn')

export default dayjs
